import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {WizardStepProps} from "../../wizard/Wizard";
import SchemaRegistry from "../registry/SchemaRegistry";
import {UploadSchemaContext} from "./context/UploadSchemaContext";

class CompleteUploadSchemaStep extends React.Component<WizardStepProps> {

  static contextType = UploadSchemaContext;

  render() {
    return (
      <Container className="CompleteUploadSchemaStep no-padding" fluid>
        <Row>
          <Col>
            <SchemaRegistry fields={['id', 'label', 'creator', 'versionInfo', 'created', 'updated', 'bound']} showActions={true}/>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default CompleteUploadSchemaStep;
